import Button from '@ixigo/iui/Button';
import Radio from '@ixigo/iui/Radio';
import Typography from '@ixigo/iui/Typography';
import { useState } from 'react';
import { useConversation } from '../../contexts/conversation';
import { ActorType } from '../../enums/conversation';
import BottomsheetHeader from '../BottomsheetHeader';
import Dialog from '../Dialog';
import { WidgetProps } from './index.types';

type Data = {
    tdrReasonList: {
        eligibility: string;
        reasonIndex: string;
        tdrReason: string;
    }[];
};

function TdrReasonSelection({ isLastMessage, message, widgetData }: WidgetProps) {
    const { sendMessage } = useConversation();
    const { actor } = message;
    const data = widgetData.parameters as Data;
    const [open, setOpen] = useState(false);
    const [selectedReason, setSelectedReason] = useState<Data['tdrReasonList'][0]>();

    const onSubmit = () => {
        const messageParts = [
            {
                isPrivate: false,
                text: {
                    content: selectedReason!.tdrReason,
                },
            },
        ];

        sendMessage({ messageParts, input: selectedReason });
    };

    if (!isLastMessage || actor.type === ActorType.USER) return null;

    return (
        <>
            <Button className='!px-20 !py-[8px] w-fit' variant='outlined' onClick={() => setOpen(true)}>
                Select Reason
            </Button>
            <Dialog
                open={open}
                classes={{ container: '!min-w-full !max-h-[calc(100%-120px)]' }}
                onClose={() => setOpen(false)}
            >
                <BottomsheetHeader title='Select Reason' onClose={() => setOpen(false)} />
                <div className='flex grow overflow-scroll'>
                    <div className='flex flex-col pb-10'>
                        {data?.tdrReasonList?.map((item) => (
                            <div
                                key={item.reasonIndex}
                                className='flex flex-col border-b border-neutral-200 cursor-pointer'
                                onClick={() => setSelectedReason(item)}
                            >
                                <div className='flex gap-5 items-center p-10'>
                                    <Radio
                                        className='m-0.5'
                                        checked={selectedReason?.reasonIndex === item.reasonIndex}
                                    />
                                    <Typography variant='body-md'>{item.tdrReason}</Typography>
                                </div>
                                {selectedReason?.reasonIndex === item.reasonIndex && item.eligibility && (
                                    <div className='p-10 bg-neutral-40'>
                                        <Typography variant='body-md'>
                                            Refund Eligibility as per Railway Refund Rules
                                        </Typography>
                                        <Typography variant='body-md' className='mt-5 text-neutral-600'>
                                            {item.eligibility}
                                        </Typography>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div className='flex gap-20 w-full p-20 pt-10'>
                    <Button variant='solid' size='lg' className='w-full' disabled={!selectedReason} onClick={onSubmit}>
                        Agree & Proceed
                    </Button>
                </div>
            </Dialog>
        </>
    );
}

export default TdrReasonSelection;
